import script from "./SocioDetallePage.vue?vue&type=script&setup=true&lang=js"
export * from "./SocioDetallePage.vue?vue&type=script&setup=true&lang=js"

import "./SocioDetallePage.vue?vue&type=style&index=0&id=619ac5ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-619ac5ff"]])

export default __exports__